import APIService from '../base'
import type { AxiosResponse } from 'axios'
import type {
  ChartOrderQuery,
  ChartResponse,
  DashboardOverview,
  TopUpOverviewChartResponse,
} from '@/types/dashboard'

export class DashboardService {
  static getOverview(
    currency: 'vnd' | 'usd',
  ): Promise<AxiosResponse<DashboardOverview>> {
    return APIService.get('/v1/admin/dashboard/overview', {
      params: {
        viewCurrency: currency,
      },
    })
  }

  static getOverviewOrderChart(
    params: ChartOrderQuery,
  ): Promise<AxiosResponse<ChartResponse>> {
    return APIService.get('/v1/admin/dashboard/orders-chart', {
      params,
    })
  }

  static getOverviewTopUpChart(
    params: ChartOrderQuery,
  ): Promise<AxiosResponse<TopUpOverviewChartResponse>> {
    return APIService.get('/v1/admin/dashboard/top-up-overview-chart', {
      params,
    })
  }
}
